// extracted by mini-css-extract-plugin
export default {"zoomModal":"A3-z"};